import React from 'react'

export const innerReplace = (text: string, tokens: Record<string, JSX.Element | string>) => {
  const [joined, remainder] = Object.entries(tokens).reduce(
    ([processedText, remainingText], [token, replacement]): [(string | JSX.Element)[], string] => {
      const [before, after] = remainingText.split(`{${token}}`)

      // Wrap in a span so we can give a key for any tokens that are JSX elements (potential React components)
      const replacedElement = typeof replacement === 'string' ? replacement : <span key={token}>{replacement}</span>

      return [[...processedText, before, replacedElement], after || '']
    },
    [[], text] as [(JSX.Element | string)[], string]
  )

  if (!remainder) return joined

  return [...joined, remainder]
}

/** Join adjacent string elements into one */
export const joinStringElements = (elements: (JSX.Element | string)[]) =>
  elements.reduce((all, curr) => {
    const last = all[all.length - 1]
    return typeof curr === 'string' && typeof last === 'string' ? [...all.slice(0, -1), last + curr] : [...all, curr]
  }, [] as (JSX.Element | string)[])

/**
 * Replace tokens in text. Will work with JSX elements.
 *
 * @param text Target text, tokens are specified like "This is my {tokenName}."
 * @param tokens Replacement strings or JSX elements. Object key is the token name (sans brackets)
 * @returns A JSX element with replacements
 */
export const replaceJSXTokens = (text: string, tokens: Record<string, JSX.Element | string>): JSX.Element => {
  return <>{joinStringElements(innerReplace(text, tokens))}</>
}
